/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path pages
 * @description Login page
 *
 * @section 4.1.2
 *
 */
import { useAuth } from "@qpr/client-library";
import React from "react";
import Login from "./../login/Login";
const LoginPage = () => {
  const { login, auth } = useAuth();
  const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const logOnName = e.currentTarget.email.value;
    const password = e.currentTarget.password.value;
    login(logOnName, password);
  };
  return <Login handleSubmit={submitHandler} errorMessage={auth.authError} />;
};
export default LoginPage;
